export const validator = (ReeValidate) => {
  // password custom validation
  ReeValidate.extend('verify_password', {
    getMessage: () => `The password must contain at least: 1 lowercase letter, 1 uppercase, 1 number, and one special character
        (E.g. !@#$ etc)`,
    validate: (value) => {
      const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
      return strongRegex.test(value);
    },
  });
  ReeValidate.extend('confirmation', (value, [otherValue]) => {
    console.log(value)
    console.log(otherValue)
    return value === otherValue;
  }, {
    hasTarget: true,
  });  
};

// validate number range
export const checkValidNumberRange = value => /^([0-9]|[0-9][0-9]|[0-9][0-9][0-0])$/.test(value);

// validate rest seconds
export const validateRestSeconds = value => /^([0-9]|[0-9][0-9]|[0-9][0-2][0-9])$/.test(value);



// WEBPACK FOOTER //
// ./src/validators.js